// extracted by mini-css-extract-plugin
module.exports = {"select":"BigSelect_select__3yB9B","full":"BigSelect_full__38X3y","control":"BigSelect_control__1zjR2","mini":"BigSelect_mini__18GtU","micro":"BigSelect_micro__20jnJ"};